import React, {Component} from 'react';
import {
    Platform,
    View,
    ScrollView,
    TouchableOpacity,
    KeyboardAvoidingView,
    ActivityIndicator,
} from 'react-native';


import {moderateScale} from '../../../../tools/Scaling';


import HMActionBar from '../../../../customviews/HMActionBar';


import i18n from '../../../../I18n/i18n.js';

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from '../../../../redux/NavigationService';
import DialogLoadingCustomize from '../../../../customviews/DialogLoadingCustomize';
import {Tools} from '../../../../tools/Tools';
import HMTextView from '../../../../customviews/HMTextView';
import Colors from '../../../../tools/Colors';
import HMImageView from '../../../../customviews/HMImageView';
import PathFile from '../../../../assets/PathFile';
import {typeExport} from '../../../../redux/store/type';

import HMLoading from '../../../../customviews/HMLoading';

import DialogConnectionCustomize from '../../../../customviews/DialogConnectionCustomize';
import store from '../../../../redux/store';
import {AsyngStorageClass} from '../../../../tools/AsyngStorageClass';
import {DialogUpdateAppCustomize} from '../../../../customviews/dialogUpdateApp/DialogUpdateAppCustomize';
import HMAlert from '../../../../customviews/HMAlert';

let container = null;
let countTest = 0;


import {callWebservice as callWebserviceSplash} from '../../splash/action/ActionSplashGetAllData';
import HMIcon from '../../../../customviews/HMIcon';
import {GoLink} from '../../../../tools/Tools1';


export default class ApplyScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        let viewportWidth = 1;
        let viewportHeight = 1;
        if (Platform.OS === 'web') {
            viewportWidth = document.documentElement.clientWidth;
            viewportHeight = document.documentElement.clientHeight;


        }
        // switch (Platform.OS) {
        //
        //     case "android":
        //         firebase = require("react-native-firebase")
        //
        //         break;
        //     default:
        //
        // }
        // if (Platform.OS === "android") {
        //      firebase = require("react-native-firebase")
        //
        // }
        this.state = {
            checkCountRequest: 0,
            columnCount: 2,
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            alaki: false,
            viewportWidth: viewportWidth,
            viewportHeight: viewportHeight,
            itemWidth: Platform.OS === 'web' ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,
        };


    }

    async getDataServerSplash() {
        this.setState({
            checkCountRequest: this.state.checkCountRequest + 1,
        });
        let dataSplash = this.props.DataSplashScreen;
        if (store.getState().reducerSplashGetAllData.token && (dataSplash.TypeLogin == 2 || dataSplash.TypeLogin == 1 || dataSplash.TypeLogin == null)) {

            let paramss = {
                'token': dataSplash.token,
                'id': 1,
                'lang': i18n.locale,
                'imei': 0,
                'token_mahale': dataSplash.tokenMahaleh,
                //  'tenant_id': store.getState().reducerSplashGetAllData?.City?.tenant_id,

                'token_fb': dataSplash.token_fb,
            };
            paramss = Tools.addAllParams(paramss);

            if (dataSplash.Connection) {

                if (global.GoOfflineToMain || !(this.props.DataSplashScreen.results)) {
                    if ((global._loadDataCount && global._loadDataCount > 0) || (global.GoOfflineToMain || !(dataSplash.TypeLogin == 2 ? dataSplash.resultsShahrdar : dataSplash.results))) {
                        if (dataSplash.TypeLogin == 2) {
                            store.dispatch(callWebserviceSplash(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, dataSplash.token, dataSplash.token_fb, null, 'MainScreen'));
                        } else {
                            store.dispatch(callWebserviceSplash(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, dataSplash.token, dataSplash.token_fb, null, 'MainScreen'));

                        }
                        //  this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, token, token_fb, imageBack);

                    }
                    else {
                        global._loadDataCount = global._loadDataCount ? global._loadDataCount + 1 : 1;
                    }
                }


                await AsyngStorageClass.setAsyng('splash' + global.IdCity, dataSplash.results);

                if (dataSplash.TypeLogin == 2) {
                    await AsyngStorageClass.setAsyng('splashShahrdar' + global.IdCity, dataSplash.resultsShahrdar);
                } else {
                    await AsyngStorageClass.setAsyng('splashSaina' + global.IdCity, dataSplash.resultsSaina);
                }

            }
            else {
                if (dataSplash.TypeLogin == 2) {
                    store.dispatch(callWebserviceSplash(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, dataSplash.token, dataSplash.token_fb, null, 'MainScreen'));
                } else {
                    store.dispatch(callWebserviceSplash(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, dataSplash.token, dataSplash.token_fb, null, 'MainScreen'));

                }
            }
        }

    }

    async componentDidMount() {

        let OrganCity = this.props.DataSplashScreen?.OrganCity;
        let user = this.props.DataSplashScreen?.user;
        let _params = this.props.route.params;
        let item = _params ? JSON.parse(_params.item) : null;

        if (item?.type != '7') {
            /*  if (!Tools.CheckValue(OrganCity) && (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") && user && user.orgs) {
                  this.setState({
                          checkCountRequest: this.state.checkCountRequest + 1
                      },
                      () => {

                      }
                  )
                  NavigationService.navigateParams("ListCityScreen", {type: "orgs"});

              }
              else {
                  //  if (this.props.DataSplashScreen.TypeLogin == 2 && (typeExport._NameApp == "MahalemaArak"))
                  let result = (this.props?.route?.key?.toString());
                  //   if (this.props.DataSplashScreen.TypeLogin == 2 && (result.search('ApplyScreen-') >= 0) && (item?.typepm == "mahale" ? true : !(item?.type == 7)) &&(typeExport._NameApp!=="MahalemaArak"))
                  if (this.props.DataSplashScreen.TypeLogin == 2 && (result.search('ApplyScreen-') >= 0) && (item?.typepm == "mahale" ? true : !(item?.type == 7)))
                      this.getDataServerSplash();
              }*/

            let result = (this.props?.route?.key?.toString());
            //   if (this.props.DataSplashScreen.TypeLogin == 2 && (result.search('ApplyScreen-') >= 0) && (item?.typepm == "mahale" ? true : !(item?.type == 7)) &&(typeExport._NameApp!=="MahalemaArak"))
            if (this.props.DataSplashScreen.TypeLogin == 2 && (result.search('ApplyScreen-') >= 0) && (item?.typepm == 'mahale' ? true : !(item?.type == 7))) {
                this.getDataServerSplash();
            }

        }
        else {
            if (this.props.DataSplashScreen.TypeLogin == 2 && (result.search('ApplyScreen-') >= 0) && typeExport._TypeApp === '1888') {
                this.getDataServerSplash();
            }
        }


        this.props.callServiceRefresh();

        this.props.navigation.addListener('focus', () => {

                let OrganCity = this.props.DataSplashScreen?.OrganCity;
                let user = this.props.DataSplashScreen?.user;
                //
                // if (!Tools.CheckValue(OrganCity)){
                //     NavigationService.Pop();
                // }

                this.setState({
                    alaki: !this.state.alaki,
                });
                container = this;
                if (item?.type != '7') {
                    if (this.state.checkCountRequest > 0) {

                        // if (!Tools.CheckValue(OrganCity) && (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") && user && user.orgs) {
                        //     // NavigationService.navigateParams("ListCityScreen");
                        //     NavigationService.Pop();
                        //
                        // }
                        //  else {// if (this.props.DataSplashScreen.TypeLogin == 2 && (typeExport._NameApp == "MahalemaArak"))
                        if (this.props.DataSplashScreen.TypeLogin == 2 && (this.props.route.key.search('ApplyScreen-') >= 0) && (typeExport._NameApp !== 'MahalemaArak')) {
                            this.getDataServerSplash();
                        }
                        //   }

                    }
                }
                else {
                    if (this.props.DataSplashScreen.TypeLogin == 2 && (result.search('ApplyScreen-') >= 0) && typeExport._TypeApp === '1888') {
                        this.getDataServerSplash();
                    }
                }
            },
        );
        this.props.navigation.addListener('blur', () => {
        });

        let {resultsShahrdar} = store.getState().reducerSplashGetAllData;
        global.list_menu_shahrdar = resultsShahrdar && resultsShahrdar.result.menu;


        // global.ref_toast.current.show({
        //     text1: 'Hello',
        //     text2: 'This is some something 👋'
        // })
        // Toast.show({
        //     text1: 'Hello',
        //     text2: 'This is some something 👋'
        // });

        if (Platform.OS === 'web') {
            window.addEventListener('resize', function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.documentElement.clientWidth;
                let viewportHeight = document.documentElement.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        viewportHeight: viewportHeight,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 600 ? 4 : 2,
                    },
                );


            });
        }
        /*  if (Platform.OS === "android") {
              const channel = new firebase.notifications.Android.Channel(
                  '1',
                  'A',
                  firebase.notifications.Android.Importance.Max
              ).setDescription('A natural description of the channel');
              firebase.notifications().android.createChannel(channel);

              // the listener returns a function you can use to unsubscribe
              this.unsubscribeFromNotificationListener = firebase.notifications().onNotification((notification) => {
                  if (Platform.OS === 'android') {
                      const localNotification = new firebase.notifications.Notification({
                          sound: 'default',
                          show_in_foreground: true,
                      }).setNotificationId(notification.notificationId)
                          .setTitle(notification.title)
                          .setSubtitle(notification.subtitle)
                          .setBody(notification.body)
                          .setData(notification.data)
                          .android.setChannelId('channelId') // e.g. the id you chose above
                          .android.setSmallIcon('logo') // create this icon in Android Studio
                          .android.setLargeIcon('logo') // create this icon in Android Studio
                          // .android.setColor('#ee3d43') // you can set a color here
                          .android.setPriority(firebase.notifications.Android.Priority.High);

                      firebase.notifications()
                          .displayNotification(localNotification)
                          .catch(err => console.error(err));

                  }
                  else if (Platform.OS === 'ios') {

                      const localNotification = new firebase.notifications.Notification()
                          .setNotificationId(notification.notificationId)
                          .setTitle(notification.title)
                          .setSubtitle(notification.subtitle)
                          .setBody(notification.body)
                          .setData(notification.data)
                          .ios.setBadge(notification.ios.badge);

                      firebase.notifications()
                          .displayNotification(localNotification)
                          .catch(err => console.error(err));
                  }


                  if (notification && notification.data && notification.data.typeOperation === '1') {
                      let item = null

                      if (notification.data.menu) {
                          item = JSON.parse(notification.data.menu.replace(new RegExp('}"', "g"), "}").replace(new RegExp('"{', "g"), "{").trim())

                          if (item.length > 0) {
                              global.list_menu_shahrdar = item;
                              this.setState({alaki: !this.state.alaki})

                          }
                      }
                  }

              });
              // if (store.getState().reducerSplashGetAllData.TypeLogin == 2)
              //     this.getData()

          }*/
        this.unsubscribeFromNotificationListener = Tools.receiveonOnNotification(this.changeMenu);

    }

    changeMenu() {
        container.setState({alaki: !container.state.alaki});
    }

    getData() {
        let {mobile, password} = this.state;

        let paramss = {
            '_operation': typeExport._Shahrdar,

            'mode': typeExport._GetCalendar,
            'lang': i18n.locale,

            //    "username": mobile,
            //  "password": password,
            //
            // "username": Tools.persianToEnglish(mobile),
            // "password": Tools.persianToEnglish(password),
            // "token_fb": this.props.DataSplashScreen.token_fb,
        };

        this.props.callService(
            typeExport.urlApplyScreen,
            paramss,
            typeExport.TypeGetApplyScreen,
            'POST',
            this.state,
        );

    }

    componentWillUnmount() {

        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener?.();
        }
    }

    render() {
        let {viewportWidth, viewportHeight} = this.state;

        let list = this.props.route.params ? this.props.route.params.list : null;
        let request_server = this.props.route.params ? this.props.route.params.request_server : null;
        // let item = this.props.route.params ? this.props.route.params.item : null;
        let _params = this.props.route.params;
        let item = _params ? JSON.parse(_params.item) : null;
        let {resultsShahrdar, user} = store.getState().reducerSplashGetAllData;
        let OrganCity = user && user.orgs ? this.props.DataSplashScreen?.OrganCity : null;

        let type = this.props.route.params ? this.props.route.params.type : null;

        let checkLogin1 = store.getState().reducerSplashGetAllData.token && (store.getState().reducerSplashGetAllData.TypeLogin == 2 || typeExport._NameApp == 'MahalemaArak');
        let checkLogin = store.getState().reducerSplashGetAllData.token && (store.getState().reducerSplashGetAllData.TypeLogin == 2 || typeExport._NameApp == 'MahalemaArak' || typeExport._TypeApp === '1888');


        let dataList = typeExport._TypeApp === '1888' ?
            (!checkLogin1 ?
                    [{
                        name: 'پیام به بازرسی',
                        //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                        //image_source: PathFile.image.Sabt_Shekayat,
                        image_source: (PathFile.image.Sabt_Shekayat),

                        typeClick: 3,
                        type: 7,
                    },
                        {
                            name: 'مشاهده نتیجه بازرسی',
                            //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                            image_source: (PathFile.image.Natije_Shekayat),

                            // image_source: PathFile.image.Natije_Shekayat,
                            typeClick: 4,
                            type: 7,
                        },
                        {
                            name: 'پیام به بازرسی (ناشناس)',
                            //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                            //image_source: PathFile.image.Sabt_Shekayat,
                            image_source: (PathFile.image.Sabt_Shekayat),

                            typeClick: 3,
                            type: 7,
                            NoLogin: true,
                        },
                        {
                            name: 'مشاهده پیام بازرسی  (ناشناس)',
                            //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                            //image_source: PathFile.image.Sabt_Shekayat,
                            image_source: (PathFile.image.Sabt_Shekayat),

                            typeClick: 4,
                            type: 7,
                            NoLogin: true,
                        },

                    ]
                    :
                    item?.type == 6 ? item?.list : resultsShahrdar && resultsShahrdar.result.menu ? global.list_menu_shahrdar : global.list_menu_shahrdar

            )

            :
            (
                checkLogin && (item?.typepm == 'mahale' ? true : !(item?.type == 7)) ?
                    (type === 'report' ?
                            (item && item.list ? item.list
                                : [
                                    {
                                        name: 'درخواستهای پر تکرار',
                                        //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                        //image_source:  PathFile.image.sabt_darkhast,
                                        image_source: PathFile.image.darkhast15,
                                        type: 1,
                                    },
                                    {
                                        name: 'وضعیت درخواست ها',
                                        //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                        // image_source: PathFile.image.Natije_Darkhast,
                                        image_source: PathFile.image.darkhastha,
                                        type: 2,
                                    },

                                    /*  {
                                          name: 'معوقه ها',
                                          //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                          // image_source: PathFile.image.Natije_Darkhast,
                                          svg: PathFile.image.darkhastha,
                                          type: 5,
                                      },*/

                                ])
                            :
                            (resultsShahrdar && resultsShahrdar.result.menu ? global.list_menu_shahrdar : global.list_menu_shahrdar)
                    )
                    :
                    (typeExport._NameApp == 'Ahvaz' || typeExport._NameApp == 'Arak' ||  typeExport._NameApp == 'Demo' || typeExport._NameApp == 'Cloud' || typeExport._NameApp == 'CloudTest' ?
                            (
                                (typeExport._NameApp == 'Cloud' || typeExport._NameApp == 'CloudTest') && (item?.typepm == 'mahale' ? true : (item?.type == 7)) ?
                                    (

                                        item?.parentType ?
                                            (item.parentType == 'request' ?
                                                    [
                                                        {
                                                            name: 'ثبت درخواست',
                                                            //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                                            //image_source:  PathFile.image.sabt_darkhast,
                                                            image_source: (PathFile.image.sabt_darkhast),
                                                            typeClick: 1,
                                                            type: 7,
                                                            typeParent: 5,
                                                            NoLogin: true,
                                                        },

                                                        {
                                                            name: 'پیام به بازرسی',
                                                            //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                            //image_source: PathFile.image.Sabt_Shekayat,
                                                            image_source: (PathFile.image.Sabt_Shekayat),

                                                            typeClick: 3,
                                                            type: 7,
                                                            NoLogin: true,
                                                        },


                                                    ]
                                                    :
                                                    [

                                                        {
                                                            name: 'مشاهده نتیجه درخواست',
                                                            //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                                            // image_source: PathFile.image.Natije_Darkhast,
                                                            image_source: (PathFile.image.Natije_Darkhast),
                                                            type: 7,
                                                            typeClick: 2,
                                                            typeParent: 5,
                                                            NoLogin: true,
                                                        },

                                                        {
                                                            name: 'مشاهده نتیجه بازرسی',
                                                            //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                            image_source: (PathFile.image.Natije_Shekayat),

                                                            // image_source: PathFile.image.Natije_Shekayat,
                                                            typeClick: 4,
                                                            type: 7,
                                                            NoLogin: true,
                                                        },

                                                    ]
                                            )
                                            :
                                            [
                                                {
                                                    name: 'ثبت درخواست',
                                                    //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                                    //image_source:  PathFile.image.sabt_darkhast,
                                                    image_source: (PathFile.image.sabt_darkhast),
                                                    typeClick: 1,
                                                    type: 7,
                                                    typeParent: 5,
                                                    NoLogin: true,
                                                },
                                                {
                                                    name: 'مشاهده نتیجه درخواست',
                                                    //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                                    // image_source: PathFile.image.Natije_Darkhast,
                                                    image_source: (PathFile.image.Natije_Darkhast),
                                                    type: 7,
                                                    typeClick: 2,
                                                    typeParent: 5,
                                                    NoLogin: true,
                                                },
                                                {
                                                    name: 'پیام به بازرسی',
                                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                    //image_source: PathFile.image.Sabt_Shekayat,
                                                    image_source: (PathFile.image.Sabt_Shekayat),

                                                    typeClick: 3,
                                                    type: 7,
                                                    NoLogin: true,
                                                },
                                                {
                                                    name: 'مشاهده نتیجه بازرسی',
                                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                    image_source: (PathFile.image.Natije_Shekayat),

                                                    // image_source: PathFile.image.Natije_Shekayat,
                                                    typeClick: 4,
                                                    type: 7,
                                                    NoLogin: true,
                                                },

                                            ]
                                    )
                                    :
                                    (
                                        item?.parentType ?
                                            (item.parentType == 'request' ?
                                                    [
                                                        {
                                                            name: 'ثبت درخواست',
                                                            //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                                            //image_source:  PathFile.image.sabt_darkhast,
                                                            image_source: (PathFile.image.sabt_darkhast),
                                                            typeClick: 1,
                                                        },

                                                        {
                                                            name: 'پیام به بازرسی',
                                                            //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                            //image_source: PathFile.image.Sabt_Shekayat,
                                                            image_source: (PathFile.image.Sabt_Shekayat),

                                                            typeClick: 3,
                                                            type: 7,
                                                        },

                                                    ] :
                                                    [
                                                        {
                                                            name: 'مشاهده نتیجه درخواست',
                                                            //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                                            // image_source: PathFile.image.Natije_Darkhast,
                                                            image_source: (PathFile.image.Natije_Darkhast),

                                                            typeClick: 2,
                                                        },
                                                        {
                                                            name: 'مشاهده نتیجه بازرسی',
                                                            //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                            image_source: (PathFile.image.Natije_Shekayat),

                                                            // image_source: PathFile.image.Natije_Shekayat,
                                                            typeClick: 4,
                                                            type: 7,
                                                        },

                                                    ]
                                            )
                                            :
                                            [
                                                {
                                                    name: 'ثبت درخواست',
                                                    //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                                    //image_source:  PathFile.image.sabt_darkhast,
                                                    image_source: (PathFile.image.sabt_darkhast),
                                                    typeClick: 1,
                                                },
                                                {
                                                    name: 'مشاهده نتیجه درخواست',
                                                    //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                                    // image_source: PathFile.image.Natije_Darkhast,
                                                    image_source: (PathFile.image.Natije_Darkhast),

                                                    typeClick: 2,
                                                },
                                                {
                                                    name: 'پیام به بازرسی',
                                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                    //image_source: PathFile.image.Sabt_Shekayat,
                                                    image_source: (PathFile.image.Sabt_Shekayat),

                                                    typeClick: 3,
                                                    type: 7,
                                                },
                                                {
                                                    name: 'مشاهده نتیجه بازرسی',
                                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                    image_source: (PathFile.image.Natije_Shekayat),

                                                    // image_source: PathFile.image.Natije_Shekayat,
                                                    typeClick: 4,
                                                    type: 7,
                                                },
                                                // 1 === 1 ? {
                                                //     name: 'کارتابل',
                                                //     //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                //     image: PathFile.image.Natije_Shekayat,
                                                //     typeClick: 5,
                                                //     type: 7
                                                // } : null
                                                // ,
                                            ]
                                    )
                            )
                            :
                            [
                                {
                                    name: 'ثبت درخواست',
                                    //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                    //  image_source: PathFile.image.sabt_darkhast,
                                    image_source: (PathFile.image.sabt_darkhast),

                                    typeClick: 1,
                                },
                                {
                                    name: 'مشاهده نتیجه درخواست',
                                    //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                    //  image_source: PathFile.image.Natije_Darkhast,
                                    image_source: (PathFile.image.Natije_Darkhast),

                                    typeClick: 2,

                                },

                            ]
                    )
            )
        ;

        /*       if (countTest === 0) {
                   countTest = 1;
                   dataList.push({
                       name: 'پیام های مدیران',
                       //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                       //image_source:  PathFile.image.sabt_darkhast,
                       image_source: PathFile.image.darkhast15,
                       svg: "https://app.iran137.com/images/svg/settings.svg",
                       type: 6,
                       list: [
                           {
                               name: 'ویرایش نقش ها',
                               //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                               //image_source:  PathFile.image.sabt_darkhast,
                               image_source: PathFile.image.darkhast15,
                               svg: "https://app.iran137.com/images/svg/role.svg",
                               type: "d_1",
                           },
                           {
                               name: 'ویرایش الگوی مشاهده داشبورد',
                               //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                               // image_source: PathFile.image.Natije_Darkhast,
                               image_source: PathFile.image.darkhast15,
                               svg: "https://app.iran137.com/images/svg/dashbord.svg",

                               type: "d_2",
                           },

                       ]
                   })
                   dataList.push({
                       name: 'داشبورد عملکرد',
                       //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                       //image_source:  PathFile.image.sabt_darkhast,
                       image_source: PathFile.image.darkhast15,
                       svg: "https://app.iran137.com/images/svg/speedometer.svg",
                       type: 9,

                   })
               }*/


        return (
            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1}} behavior={'padding'}
                                          enabled={Platform.OS === 'ios'}>
                        <HMActionBar
                            //  menu={!checkLogin}
                            menu={typeExport._NameApp != 'MahalemaArak' || typeExport._TypeApp === '1888'}
                            // menu
                            back={(typeExport._NameApp != 'MahalemaArak' && (typeExport._TypeApp !== '1888' || (typeExport._TypeApp === '1888' && item?.type)))}
                            //  exit={checkLogin && !type}
                            //  exit={checkLogin && !type}
                            exit={typeExport._NameApp == 'MahalemaArak' || (typeExport._TypeApp === '1888' && !(item?.type))}
                            funcExit={checkLogin ? () => {

                                HMAlert(
                                    i18n.t('constant.message'),
                                    'آیا می خواهید از حساب کاربری خود خارج شوید؟',
                                    [
                                        // {text: 'Ask me later', onPress: () => {}},
                                        {
                                            text: i18n.t('constant.No'), onPress: () => {
                                            }, style: 'cancel',
                                        },
                                        {
                                            text: i18n.t('constant.Yes'), onPress: () => {
                                                AsyngStorageClass.removeToken(typeExport._Shahrdar);
                                                NavigationService.resetTo('LoginStackScreen');

                                            },
                                        },
                                    ],
                                    {cancelable: true},
                                );


                                // Tools.remove()
                                // NavigationService.resetTo("SplashScreen")
                            } : null}
                            props={this.props} statusBarTransparent
                            //  text={i18n.t('Apply.title')}
                            // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? this.props.DataSplashScreen.user.name + " " + this.props.DataSplashScreen.user.family : null}
                            text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? i18n.t('appName') : null}
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}
                            // funcExit={checkLogin ? () => {
                            //
                            //     HMAlert(
                            //         i18n.t('constant.message'),
                            //         "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                            //         [
                            //             // {text: 'Ask me later', onPress: () => {}},
                            //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            //             {
                            //                 text: i18n.t('constant.ok'), onPress: () => {
                            //                     AsyngStorageClass.removeToken(typeExport._Shahrdar);
                            //                 }
                            //             },
                            //         ],
                            //         {cancelable: true}
                            //     )
                            //
                            //
                            //     // Tools.remove()
                            //     // NavigationService.resetTo("SplashScreen")
                            // } : null}
                            styleText={[!checkLogin ? {} : {marginStart: moderateScale(48)}]}
                            /*    ViewCenter={
                                    (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") && OrganCity && (item?.typepm == "mahale" ? true : !(item?.type == 7)) ?
                                        () => {
                                            return <View style={{flexDirection: "row"}}>

                                                <HMTextView
                                                    numberOfLines={1}
                                                    text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? i18n.t('appName') : null}
                                                    type="bold"
                                                    style={{
                                                        alignSelf: "center",
                                                        color: Colors.light,
                                                        fontSize: moderateScale(16),
                                                    }}
                                                />

                                                <HMTextView
                                                    numberOfLines={1}
                                                    text={OrganCity ? ` (${OrganCity.name}) ` : ""}
                                                    type="bold"
                                                    style={{
                                                        alignSelf: "center",
                                                        color: Colors.light,
                                                        fontSize: moderateScale(16),
                                                        marginHorizontal: moderateScale(8)
                                                    }}
                                                />

                                                <HMIcon
                                                    type={"AntDesign"}
                                                    // source={check ?( Platform.OS === "web" ? {uri:typeExport._baseUrlImageAssets+ "check-mark.png"} : PathFile.image.Check ): null}
                                                    name={"sync"}
                                                    //resizeMode="stretch"
                                                    style={[{fontSize: moderateScale(24)}, {
                                                        color: Colors.white
                                                    }]}
                                                    onPress={() => {
                                                        NavigationService.navigateParams("ListCityScreen", {type: "orgs"})
                                                    }}
                                                />
                                            </View>
                                        }
                                        :
                                        null
                                }*/
                        />

                        {
                            (!this.props.DataSplashScreen.NoInternetDialogShahrdar) && (!this.props.DataSplashScreen.isLoadingShahrdar) ?
                                null
                                :
                                <View
                                    style={{
                                        width: '100%',
                                        //  flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: this.props.DataSplashScreen.NoInternetDialogShahrdar ? Colors.red : Colors.white,
                                        alignSelf: 'center',
                                        padding: moderateScale(6),
                                    }}
                                >
                                    {this.props.DataSplashScreen.NoInternetDialogShahrdar ?
                                        <View
                                            style={{
                                                width: '100%',
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={'bold'}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: 'center',
                                                        color: Colors.white,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={'خطایی رخ داده مجددا تلاش نمایید'}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.getDataServerSplash();

                                                }}
                                                style={{
                                                    // flex: .33,
                                                    // width: '92%',
                                                    // height: moderateScale(28),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.yellow,
                                                    borderRadius: moderateScale(6),
                                                    marginHorizontal: moderateScale(2),
                                                    paddingHorizontal: moderateScale(4),
                                                    paddingVertical: moderateScale(2),


                                                }}>

                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={i18n.t('constant.Update')}
                                                    //  text={"ثبت و بستن تیکت"}
                                                    type={'bold'}
                                                    style={{
                                                        fontSize: moderateScale(10),
                                                        marginVertical: moderateScale(2),
                                                        //     marginHorizontal: moderateScale(4),
                                                        color: Colors.white,
                                                    }}/>
                                            </TouchableOpacity>

                                        </View>
                                        :

                                        <View
                                            style={{
                                                width: '100%',
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={'bold'}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: 'center',
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={i18n.t('constant.Update')}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <ActivityIndicator color={Colors.colorPrimary} size={'small'}/>

                                        </View>
                                    }
                                </View>


                        }
                        {/*       <View style={{width: "100%", height: moderateScale(200)}}>
                            <HMSvgXml xml={xml} width="100%" height="100"/>
                        </View>*/}
                        <View style={{flex: 1, alignItems: 'center'}}>

                            {
                                this.props.results == null && this.props.isLoading && request_server ?
                                    <HMLoading/>

                                    :
                                    <ScrollView
                                        style={{
                                            //   backgroundColor:"#dd2dee"
                                        }}>
                                        <View
                                            style={{
                                                //position:'absolute',
                                                flexDirection: 'row',
                                                flexWrap: 'wrap',
                                                flex: 1,

                                                flexGrow: 1,
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginTop: moderateScale(12),
                                                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                                                //  backgroundColor: "#876a79",
                                            }}>


                                            {
                                                dataList && dataList.length > 0 ?
                                                    dataList.map((item, key) => {
                                                        //  (this.state.data).find((obj) => obj.locale == i18n.locale).list.map((item, key) => {
                                                        return (
                                                            //type=0 => پیوند ,type=1 => اخبار ,type=2 => صفحه ,type=3 => منو ,type=4 => اسلایدر ,type=5 => 137 یار ,type=6 => نقشه ,,type=7 => بازرسی ,,type=8 =>  ارامستان ,
                                                            <TouchableOpacity
                                                                key={key + 'iii'}
                                                                onPress={() => {

                                                                    if (checkLogin && (item?.typepm == 'mahale' ? true : !(item?.type == 7))) {

                                                                        if (type === 'report') {

                                                                            switch (item.type) {
                                                                                case 1000:
                                                                                    // Toast.show({
                                                                                    //     text1: 'Hello',
                                                                                    //     text2: 'This is some something 👋'
                                                                                    // })

                                                                                    GoLink(item.url_link);
                                                                                    break;
                                                                                case 1:
                                                                                    NavigationService.navigateParams('ListReport15RequestScreen', {
                                                                                        data: item, Extras: item,
                                                                                    });
                                                                                    break;

                                                                                case 2:
                                                                                    NavigationService.navigateParams('ListReportStatusRequestScreen', {
                                                                                        data: item,
                                                                                        Extras: item,
                                                                                        type: 'report',
                                                                                    });
                                                                                    break;

                                                                                case 3:
                                                                                    NavigationService.navigateParams('ListReport15RequestScreen', {
                                                                                        data: item, Extras: item,
                                                                                    });
                                                                                    break;

                                                                                case 4:
                                                                                    NavigationService.navigateParams('ListReportStatusRequestScreen', {
                                                                                        data: item,
                                                                                        Extras: item,
                                                                                        type: 'report',
                                                                                    });
                                                                                    break;

                                                                                case 5:
                                                                                    NavigationService.navigateParams('ListReportArrearsScreen', {
                                                                                        data: item,
                                                                                        Extras: item,
                                                                                        type: 'report',
                                                                                    });
                                                                                    break;


                                                                                case 'm_1':
                                                                                    if (this.props.DataSplashScreen.tokenMahaleh) {
                                                                                        NavigationService.navigateParams('ListOperatorApplyScreen', {
                                                                                            item: item,
                                                                                            data: item,
                                                                                            Extras: item,
                                                                                            itemOriginal: item,
                                                                                            type: 'requestMahalehMa',
                                                                                        });
                                                                                    }
                                                                                    else {
                                                                                        AsyngStorageClass.removeToken();
                                                                                    }

                                                                                    break;

                                                                                case 'm_2':
                                                                                    if (this.props.DataSplashScreen.tokenMahaleh) {
                                                                                        NavigationService.navigateParams('ListReportExitEnterMahalehMaScreen', {
                                                                                            data: item,
                                                                                            Extras: item,
                                                                                            type: 'report',
                                                                                        });
                                                                                    }
                                                                                    else {
                                                                                        AsyngStorageClass.removeToken();
                                                                                    }
                                                                                    break;
                                                                                case 'd_1':

                                                                                    //  NavigationService.navigateParams("ListReportCategoryScreen", {
                                                                                    //   NavigationService.navigateParams("ApplyScreen", {
                                                                                    //       // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                    //       data: item, item: item,
                                                                                    //   })

                                                                                    //if (this.props.DataSplashScreen.tokenLaravel) {
                                                                                        NavigationService.navigateKeyDynamic('UnitsMyStateScreen', {
                                                                                            // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                            data: item,
                                                                                            item: item,
                                                                                            itemOriginal: item,
                                                                                            type: 'requestMahalehMa',
                                                                                        });
                                                                                    // }
                                                                                    // else {
                                                                                    //     AsyngStorageClass.removeToken();
                                                                                    // }
                                                                                    break;

                                                                                case 'd_2':
                                                                                   // if (this.props.DataSplashScreen.tokenLaravel) {
                                                                                        NavigationService.navigateKeyDynamic('EditPatternShowMyStateScreen', {
                                                                                            //  NavigationService.navigateKeyDynamic("DashboardMyStateScreen", {
                                                                                            // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                            data: item,
                                                                                            item: item,
                                                                                            itemOriginal: item,
                                                                                            type: 'requestMahalehMa',
                                                                                        });
                                                                                    // }
                                                                                    // else {
                                                                                    //     AsyngStorageClass.removeToken();
                                                                                    // }
                                                                                    break;


                                                                                default:
                                                                            }
                                                                        }
                                                                        else {
                                                                            switch (item.type) {

                                                                                case 1000:
                                                                                    // Toast.show({
                                                                                    //     text1: 'Hello',
                                                                                    //     text2: 'This is some something 👋'
                                                                                    // })

                                                                                    GoLink(item.url_link);
                                                                                    break;
                                                                                case 1:
                                                                                    // Toast.show({
                                                                                    //     text1: 'Hello',
                                                                                    //     text2: 'This is some something 👋'
                                                                                    // })

                                                                                    NavigationService.navigateParams('ListOperatorApplyScreen', {
                                                                                        //  NavigationService.navigateParams("ListUserChatScreen", {
                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item, item: item,
                                                                                    });
                                                                                    break;

                                                                                case 2:
                                                                                    NavigationService.navigateParams('ListOperatorApplyScreen', {

                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item, item: item,
                                                                                    });
                                                                                    break;
                                                                                case 3:
                                                                                    // NavigationService.navigateParams("SubmitRequestOperationScreen", {
                                                                                    //     // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                    //     data: item, item: item,
                                                                                    //     //position: {coords: {longitude: 46.574522, latitude: 39.454875}}
                                                                                    //   //  position: {coords: {longitude: 46.574522, latitude: 39.454875}}
                                                                                    // })

                                                                                    this.setState({isLoading: true}, () => {
                                                                                        Tools.checkPermission(
                                                                                            'SubmitRequestScreen',
                                                                                            item,
                                                                                            null,
                                                                                            this.goScreen,
                                                                                            this.stateError,
                                                                                        );
                                                                                    });
                                                                                    break;

                                                                                case 4:
                                                                                    NavigationService.navigateParams('ListMyApplyOperationScreen', {

                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item, item: item,
                                                                                    });
                                                                                    break;

                                                                                case 5:

                                                                                    NavigationService.navigateParams('GalleryServiceOperationScreen', {

                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item, item: item,
                                                                                    });
                                                                                    break;

                                                                                case 6:

                                                                                    //  NavigationService.navigateParams("ListReportCategoryScreen", {
                                                                                    //   NavigationService.navigateParams("ApplyScreen", {
                                                                                    //       // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                    //       data: item, item: item,
                                                                                    //   })
                                                                                    NavigationService.navigateKeyDynamic('ApplyScreen', {
                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: JSON.stringify(item),
                                                                                        item: JSON.stringify(item),
                                                                                        itemOriginal: item,
                                                                                        type: 'report',
                                                                                    });
                                                                                    break;


                                                                                case 7:

                                                                                    //  NavigationService.navigateParams("ListReportCategoryScreen", {
                                                                                    //   NavigationService.navigateParams("ApplyScreen", {
                                                                                    //       // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                    //       data: item, item: item,
                                                                                    //   })
                                                                                    NavigationService.navigateKeyDynamic('ListOperatorApplyScreen', {
                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item,
                                                                                        item: item,
                                                                                        itemOriginal: item,
                                                                                        type: 'requestMahalehMa',
                                                                                    });
                                                                                    break;

                                                                                case 9:
                                                                                    NavigationService.navigateParams('DashboardMyStateScreen', {
                                                                                        data: item,
                                                                                        Extras: item,
                                                                                        type: 'report',
                                                                                    });
                                                                                    break;
                                                                                case 10:
                                                                                    NavigationService.navigateParams('GalleryServiceOperationScreen', {
                                                                                        // NavigationService.navigateParams("ListOperatorFireApplyScreen", {
                                                                                        data: item, item: item,
                                                                                    });
                                                                                    break;
                                                                                default:
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        switch (item.typeClick) {
                                                                            case 1000:
                                                                                // Toast.show({
                                                                                //     text1: 'Hello',
                                                                                //     text2: 'This is some something 👋'
                                                                                // })

                                                                                GoLink(item.url_link);
                                                                                break;
                                                                            case 1:
                                                                                // this.setState({isLoading: true,}, () => {
                                                                                //     Tools.checkPermission(
                                                                                //         "SubmitRequestScreen",
                                                                                //         item,
                                                                                //         null,
                                                                                //         this.goScreen,
                                                                                //         this.stateError
                                                                                //     )
                                                                                // })
                                                                                // NavigationService.navigateParams("SubmitRequestScreen", {
                                                                                //     item: this.props.route.params.item, data: item
                                                                                // })


                                                                                // container.setState({isLoading: false})

                                                                                NavigationService.navigateParams('SubmitRequestScreen', {
                                                                                    // position: JSON.stringify(Tools.cloneAsObject(position)),
                                                                                    //   position: JSON.stringify(position),
                                                                                    position: null,
                                                                                    typeComponent: (store.getState().reducerSplashGetAllData.TypeLogin == 2) ? 'Operation' : null,
                                                                                    item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : JSON.stringify(item),
                                                                                    data: JSON.stringify(item),
                                                                                    type: 'SubmitRequestScreen',
                                                                                });
                                                                                break;

                                                                            case 2:
                                                                                NavigationService.navigateParams('ListMyApplyScreen', {
                                                                                    item: this.props.route.params.item,
                                                                                    itemOriginal: this.props.route.params.itemOriginal,
                                                                                    data: JSON.stringify(item),
                                                                                });
                                                                                break;

                                                                            case 3:
                                                                                NavigationService.navigateParams('RegisterComplaintsScreen', {
                                                                                    item: this.props.route?.params?.item,
                                                                                    data: item,
                                                                                });
                                                                                break;

                                                                            case 4:
                                                                                NavigationService.navigateParams('ListMyRegisterComplaintsScreen', {
                                                                                    item: this.props.route?.params?.item,
                                                                                    data: item,
                                                                                });
                                                                                break;

                                                                            case 5:
                                                                                NavigationService.navigateParams('ApplyScreen2',
                                                                                    {
                                                                                        item: JSON.stringify(this.props.route.params.item),
                                                                                        data: JSON.stringify(item),
                                                                                        request_server: true,
                                                                                        list:
                                                                                            [
                                                                                                {
                                                                                                    name: 'درخواست ها و شکایات جدید',
                                                                                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                                                                    image: PathFile.image.Natije_Shekayat,
                                                                                                    typeClick: 1,
                                                                                                    type: 7,
                                                                                                },
                                                                                                {
                                                                                                    name: 'در دست بررسی و اقدام',
                                                                                                    //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                                                                    image: PathFile.image.Natije_Shekayat,
                                                                                                    typeClick: 2,
                                                                                                    type: 7,
                                                                                                },

                                                                                            ],
                                                                                    });
                                                                                break;

                                                                            default:
                                                                        }
                                                                    }

                                                                }}
                                                                style={{
                                                                    // width: "100%",

                                                                    //  width: '100%',
                                                                    //  flex:1,
                                                                    height: this.state.itemWidth / 3 + moderateScale(10),
                                                                    marginHorizontal: moderateScale(4),
                                                                    marginBottom: moderateScale(4),
                                                                    borderRadius: moderateScale(6),
                                                                    //borderColor: '#d0d8df',
                                                                    borderColor: '#164A70',
                                                                    backgroundColor: Colors.white,
                                                                    borderWidth: moderateScale(1),
                                                                    //  marginVertical: moderateScale(2),
                                                                    // padding: moderateScale(6)
                                                                }}>
                                                                <View style={{
                                                                    flex: .8,
                                                                    width: this.state.itemWidth / 3 - moderateScale(10),
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}>

                                                                    <View
                                                                        style={{
                                                                            width: this.state.itemWidth / 7,
                                                                            height: this.state.itemWidth / 7,
                                                                        }}
                                                                    >
                                                                        {
                                                                            item.svg ?

                                                                                <HMIcon

                                                                                    //source={require('../../../../../assets/img/success.png')}
                                                                                    //source={PathFile.image.background}
                                                                                    //svg={PathFile.svg.add}
                                                                                    type={'svg'}
                                                                                    uri={item.svg}
                                                                                    height={this.state.itemWidth / 7}
                                                                                    width={this.state.itemWidth / 7}

                                                                                    name={'add-circle-sharp'} style={{
                                                                                    // fontSize: moderateScale(20),
                                                                                    // color: Colors.blue,
                                                                                    // marginHorizontal: moderateScale(4),
                                                                                    marginRight: moderateScale(4),
                                                                                    marginLeft: moderateScale(4),
                                                                                    //  marginTop: moderateScale(3)
                                                                                }}/>
                                                                                :
                                                                                (item.image_source ?

                                                                                        <HMImageView
                                                                                            // resizeMode={FastImage.resizeMode.contain}
                                                                                            resizeMode={'contain'}
                                                                                            _backgroundColorLoading={Platform.OS === 'web' ? Colors.transparent : null}
                                                                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                            // uriComplete={item.image}
                                                                                            source_image={item.image_source}
                                                                                            styleText={{marginTop: moderateScale(10)}}
                                                                                            borderRadius={4}/>
                                                                                        :
                                                                                        <HMImageView
                                                                                            // resizeMode={FastImage.resizeMode.contain}
                                                                                            resizeMode={'contain'}
                                                                                            _backgroundColorLoading={Platform.OS === 'web' ? Colors.transparent : null}

                                                                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                            uriComplete={item.image}
                                                                                            //source_image={item.image}
                                                                                            styleText={{marginTop: moderateScale(10)}}
                                                                                            borderRadius={4}/>
                                                                                )
                                                                        }
                                                                    </View>
                                                                    {
                                                                        item.count ?
                                                                            <View
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: 0,
                                                                                    right: 0,
                                                                                    backgroundColor: Colors.red,
                                                                                    height: moderateScale(30),
                                                                                    width: moderateScale(30),
                                                                                    borderRadius: moderateScale(15),
                                                                                    margin: moderateScale(4),
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                }}>

                                                                                <HMTextView
                                                                                    numberOfLines={1}
                                                                                    type={'bold'}
                                                                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                                                    text={item.count}

                                                                                    style={{
                                                                                        fontSize: moderateScale(10),

                                                                                        color: Colors.white,


                                                                                        //  textAlign: "right",
                                                                                    }}/>

                                                                            </View>
                                                                            :
                                                                            null
                                                                    }
                                                                </View>

                                                                <View style={{
                                                                    flex: .2,
                                                                    //backgroundColor: "#f4f4f4",
                                                                    backgroundColor: '#164A70',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    borderTopColor: '#d0d8df',
                                                                    borderBottomColor: Colors.transparent,
                                                                    borderRightColor: Colors.transparent,
                                                                    borderLeftColor: Colors.transparent,
                                                                    borderWidth: moderateScale(1),
                                                                }}>
                                                                    <HMTextView
                                                                        numberOfLines={2}
                                                                        type={'bold'}
                                                                        // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                                        text={item.name}
                                                                        style={{
                                                                            fontSize: moderateScale(13),

                                                                            color: Colors.white,
                                                                            marginTop: moderateScale(4),
                                                                            //  textAlign: "right",
                                                                        }}/>
                                                                </View>


                                                            </TouchableOpacity>
                                                        ); //if you have a bunch of keys value pair

                                                    })
                                                    :
                                                    null

                                            }
                                        </View>
                                    </ScrollView>

                                //
                                // <FlatList
                                //     style={{marginTop: moderateScale(6)}}
                                //     // ItemSeparatorComponent={
                                //     //     <View style={{
                                //     //         width: '100%',
                                //     //         height: moderateScale(1),
                                //     //         backgroundColor: '#4f4f4f'
                                //     //     }}/>
                                //     // }
                                //     // data={comment === null || !comment ? [] : comment}
                                //     numColumns={this.state.columnCount}
                                //     key={this.state.columnCount}
                                //     //type => 1=  , 2= , 3= , 4= ,
                                //     data={checkLogin ? (resultsShahrdar.result.menu ? global.list_menu_shahrdar : []) : typeExport._NameApp == "Arak" ?
                                //         [
                                //             {
                                //                 name: 'ثبت درخواست',
                                //                 //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                //                 image_source: PathFile.image.sabt_darkhast,
                                //                 typeClick: 1,
                                //             },
                                //             {
                                //                 name: 'مشاهده نتیجه درخواست',
                                //                 //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                //                 image_source: PathFile.image.Natije_Darkhast,
                                //                 typeClick: 2,
                                //             },
                                //             {
                                //                 name: 'پیام به بازرسی',
                                //                 //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                //                 image_source: PathFile.image.Sabt_Shekayat,
                                //                 typeClick: 3,
                                //                 type: 7
                                //             },
                                //             {
                                //                 name: 'مشاهده نتیجه شکایات',
                                //                 //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                //                 image_source: PathFile.image.Natije_Shekayat,
                                //                 typeClick: 4,
                                //                 type: 7
                                //             },
                                //             // 1 === 1 ? {
                                //             //     name: 'کارتابل',
                                //             //     //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                //             //     image: PathFile.image.Natije_Shekayat,
                                //             //     typeClick: 5,
                                //             //     type: 7
                                //             // } : null
                                //             // ,
                                //         ]
                                //         : [
                                //             {
                                //                 name: 'ثبت درخواست',
                                //                 //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                //                 image_source: PathFile.image.sabt_darkhast,
                                //                 typeClick: 1,
                                //             },
                                //             {
                                //                 name: 'مشاهده نتیجه درخواست',
                                //                 //image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/armfinal.png',
                                //                 image_source: PathFile.image.Natije_Darkhast,
                                //                 typeClick: 2,
                                //             },
                                //
                                //         ]
                                //
                                //     }
                                //     renderItem={this.renderItems}
                                //
                                //
                                // />
                                //
                                //

                            }

                            {
                                this.state.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                            }

                            {
                                checkLogin ?
                                    <DialogUpdateAppCustomize/>
                                    :
                                    null
                            }
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }


    goScreen(route, item, position) {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2);

        container.setState({isLoading: false});
        NavigationService.navigateParams(route, {
            position: JSON.stringify(Tools.cloneAsObject(position)),
            //   position: JSON.stringify(position),
            //  position:position,
            typeComponent: checkLogin ? 'Operation' : null,
            item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : JSON.stringify(item),
            data: JSON.stringify(item),
            type: route,
        });
    }

    stateError() {
        container.setState({
            locationEnabled: false,
            isLoading: false,
        }, () => {
        });
    }

}
